import { render } from "./Postule.vue?vue&type=template&id=630f16b5&scoped=true"
import script from "./Postule.vue?vue&type=script&lang=js"
export * from "./Postule.vue?vue&type=script&lang=js"

import "./Postule.vue?vue&type=style&index=0&id=630f16b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630f16b5"]])

export default __exports__